import styled from 'styled-components';
import {
  Grid as SemanticGrid,
  Icon as SemanticIcon,
} from 'semantic-ui-react';

import { Text as TextLayoutComponent } from '@playbookux/playbook-web-core';

const NoResults = styled(TextLayoutComponent)`
  margin: auto;
`;

const Grid = styled(SemanticGrid)`
  &&& {
    margin-bottom: 15px;
  }
`;

const Name = styled(TextLayoutComponent)`
  display: block;
  width: 10ch;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
`;

const Answer = styled(TextLayoutComponent)``;

const Link = styled.a`
  display: flex;
  flex-direction: row;
`;

const Icon = styled(SemanticIcon)`
  &&& {
    margin-left: 5px;
  }
`;

export {
  Answer,
  Grid,
  Icon,
  Link,
  Name,
  NoResults,
};
